import enLocale from './en';
import zhLocale from './zh';

export default {
  zh: zhLocale,
  en: enLocale,
};
